export default {
  light: '1px solid',
  medium: '2px solid',
};
